import {useHostSelector} from 'hooks/hostHooks/hostHooks';
import {getRouting} from 'selectors/routing';

/**
 * Custom hook to determine if the current page is the cart page.
 * @returns {{ isCartPage: boolean }} Object containing a boolean value indicating if the current page is the cart page.
 */
export const useIsCartPage = () => {
    const {location} = useHostSelector(store => getRouting(store));

    const isCartPage = Boolean(location) && location?.pathname.startsWith('/checkout/cart');

    return {
        isCartPage,
    };
};
